const VUE_APP_API_SMS_URL = document.querySelector("body").getAttribute("api_sms_url");

export default VUE_APP_API_SMS_URL
